import hoverintent from "hoverintent";

(function () {
  const body = document.body;
  const menu = document.getElementById("main-menu");
  const itemsHasChildren = menu.querySelectorAll(".menu-item-has-children");

  // Set the title of the menu item as a data attribute
  for (const li of itemsHasChildren) {
    if (!li) continue;

    const link = li.querySelector("a");
    if (!link) continue;

    link.nextElementSibling.dataset.title = link.textContent;
  }

  // Show/hide submenu on hover
  if (window.innerWidth > 999) {
    for (const li of itemsHasChildren) {
      if (!li) continue;

      hoverintent(
        li,
        () => {
          // hoverIntentIn
          li.dataset.showSubmenu = true;
          body.classList.add("sub-menu-showing");
        },
        () => {
          // hoverIntentOut
          li.dataset.showSubmenu = "";
          body.classList.remove("sub-menu-showing");
        }
      );
    }
  }
})();
